<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import BasePaywallModal from './BasePaywallModal.vue';

const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const currentAccountId = useMapGetter('getCurrentAccountId');
const isOnLumeratecCloud = useMapGetter('globalConfig/isOnLumeratecCloud');
const { t } = useI18n();

const moduleLabelKeys = {
  ia: 'LUMERAI',
  campaigns: 'CAMPAIGNS',
  tickets: 'TICKETS',
  reports: 'REPORTS',
  sla: 'SLA',
  sms: 'SMS',
  alerts: 'ALERTS',
  automations: 'AUTOMATIONS',
  macros: 'MACROS',
  custom_roles: 'CUSTOM_ROLES',
  channel_voice: 'CHANNEL_VOICE',
};

const moduleName = computed(
  () => route.query.module || t('MODULE_PAYWALL.MODULES.OTHER')
);
const moduleLabel = computed(() =>
  moduleLabelKeys[moduleName.value]
    ? // The key is resolved only through the fixed module-label map above.
      // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
      t(`MODULE_PAYWALL.MODULES.${moduleLabelKeys[moduleName.value]}`)
    : moduleName.value
);
const isSuperAdmin = computed(() => currentUser.value?.type === 'SuperAdmin');

const goToModuleStore = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: currentAccountId.value },
    query: { tab: 'store', module: moduleName.value },
  });
};
</script>

<template>
  <div class="flex flex-col items-center justify-center w-full min-h-[28rem]">
    <div class="mb-5 text-center">
      <span class="i-lucide-lock-keyhole text-n-brand text-3xl" />
      <h1 class="mt-3 text-xl font-semibold text-n-slate-12">
        {{ moduleLabel }} {{ t('MODULE_PAYWALL.DISABLED_SUFFIX') }}
      </h1>
      <p class="mt-2 text-sm text-n-slate-11">
        {{ t('MODULE_PAYWALL.DESCRIPTION') }}
      </p>
    </div>
    <BasePaywallModal
      feature-prefix="MODULE_PAYWALL"
      i18n-key="PAYWALL"
      :is-on-lumeratec-cloud="isOnLumeratecCloud"
      :is-super-admin="isSuperAdmin"
      upgrade-to-app-store
      @upgrade="goToModuleStore"
    />
  </div>
</template>
